export const SIGN_IN_PATH = '/sign-in'
export const HOME_PATH = '/home'
export const DEAL_VIEW_PATH = '/deal-view'
export const SELECTION_PATH = '/selection'
export const SELECTION_ID_PATH = '/selection/:id'

export const ROUTES_BAR = {
  [HOME_PATH]: [{ title: 'pageTitles.home', path: HOME_PATH }]
}

export const NEW_SEO = 'seo_new'
export const NEW_WL = 'wl_new'

export const SELECTION_STEP_PATH_LOADED = id => ({
  [NEW_WL]: `${HOME_PATH}${SELECTION_PATH}/${NEW_WL}`,
  [NEW_SEO]: `${HOME_PATH}${SELECTION_PATH}/${id}/${NEW_SEO}`,
  0: `${HOME_PATH}${SELECTION_PATH}/${id}/${0}`,
  1: `${HOME_PATH}${SELECTION_PATH}/${id}/${1}`,
  2: `${HOME_PATH}${SELECTION_PATH}/${id}/${2}`,
  3: `${HOME_PATH}${SELECTION_PATH}/${id}/${3}`,
  4: `${HOME_PATH}${SELECTION_PATH}/${id}/${4}`
})
